// assets
import { IconQuestionMark, } from '@tabler/icons';

// constant
const icons = {
    IconQuestionMark,
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const questionPage = {
    id: 'question management',
    title: 'User Question Management',
    caption: 'manage question list',
    type: 'group',
    children: [
        {
            id: 'fetchQuestion',
            title: 'Question',
            type: 'item',
            url: '/question/View',
            icon:icons.IconQuestionMark
        }
    ],

};

export default questionPage ;